import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import ImageSlider from "../common/ImageSlider";
import { settings } from "../../constants/spaceFeedImageSettings";
import { Link, useNavigate } from "react-router-dom";
import api from "../../api/config";
import { toast } from "react-toastify";

const FavoriteList = ({ favouriteList, setFavouriteList }) => {
  const navigate = useNavigate();

  function cleanAddress(address) {
    return address
    .replace(/,\s*USA/g, '')                 // Remove ", USA"
    .replace(/\bUnited States\b/gi, '')      // Remove "United States" (case-insensitive)
    .replace(/\bNew York\b,?\s*/gi, '')      // Remove "New York" and any following comma and space (case-insensitive)
    .replace(/\b[A-Z]{2,}\b/g, '')           // Remove state abbreviations (two or more uppercase letters)
    .trim();                                 // Trim any leading or trailing whitespace
                              

  }

  // Update favouriteList addresses
  favouriteList.forEach((item) => {
    item.spaceFeed.address1 = cleanAddress(item.spaceFeed.address1);
  });

  let auth = localStorage?.getItem("data");
  auth = JSON.parse(auth);

  const handleStarClick = (e, id) => {
    e.preventDefault();
    const isFavourite = favouriteList?.some((item) => item?.spaceFeedId === id);
    const updatedFavourites = isFavourite
      ? favouriteList?.filter((product) => product?.spaceFeedId !== id)
      : [...favouriteList, { spaceFeedId: id }]; // Add product if not already favourited
    setFavouriteList(updatedFavourites);

    handleFavourite(id, isFavourite ? 0 : 1);
  };

  const handleFavourite = async (id, action) => {
    if (!!auth?.jwt) {
      try {
        await api.post(`shortlist-space-feed/${id}/${action}`);
        toast.success(
          `${action === 1 ? "Added to Favourite" : "Removed from Favourite"}`
        );
      } catch (error) {
        toast.error("Error adding or removing from favorites!");
        console.error(error, "error");
      }
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      {favouriteList?.map((item) => {
        return (
          <div
            className="col-md-3 mb-5 ml-2 mr-2 cursor-pointer"
            style={{ display: "flex", flexWrap: "wrap" }}
          >
            <Link
              className="card position-relative cursor-pointer"
              style={{
                minHeight: "350px",
                flex: 1,
                textDecoration: "none",
                color: "inherit",
              }}
              to={`/property-detail/${item?.spaceFeedId}`}
            >
              {item?.spaceFeed?.spaceFeedMedia?.length > 0 && (
                <>
                  {item?.spaceFeed?.spaceFeedMedia?.length === 1 ? (
                    <>
                      {item?.spaceFeed?.spaceFeedMedia[0]?.url?.includes(
                        "mp4"
                      ) ? (
                        <>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "300px",
                              cursor: "pointer",
                            }}
                          >
                            <video
                              type="video/mp4"
                              src={item?.spaceFeed?.spaceFeedMedia[0]?.url}
                              alt="Card cap"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                cursor: "pointer",
                              }}
                              controls
                            />
                            {/* <FontAwesomeIcon
                              icon={faStar}
                              className="star-icon"
                              style={{
                                color: "#F5C000",
                                cursor: "default",
                              }}
                            /> */}
                            {auth?.role === "user" && (
                              <FontAwesomeIcon
                                icon={faStar}
                                onClick={(e) =>
                                  handleStarClick(e, item?.spaceFeedId)
                                }
                                className="star-icon"
                                style={{
                                  color:
                                    !!auth?.jwt &&
                                    favouriteList.some(
                                      (favProduct) =>
                                        favProduct.spaceFeedId ===
                                        item?.spaceFeedId
                                    ) &&
                                    "#F5C000",
                                  cursor: "default",
                                }}
                              />
                            )}
                          </div>
                          <div className="card-body d-flex justify-content-between align-items-start">
                            <div>
                              <h5 className="card-title">
                                {item?.spaceFeed?.name}
                              </h5>
                              <p className="card-text margin-custum">
                            {item?.spaceFeed?.address1}
                                {/* {item?.spaceFeed?.city},{" "} */}
                                {/* {item?.spaceFeed?.state} 
                                {item?.spaceFeed?.pin} */}
                              </p>
                            </div>
                            <div></div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "300px",
                            }}
                          >
                            <img
                              src={item?.spaceFeed?.spaceFeedMedia[0]?.url}
                              alt=""
                              className="card-img-top"
                              style={{ height: "300px" }}
                            />
                            {auth?.role === "user" && (
                              <FontAwesomeIcon
                                icon={faStar}
                                onClick={(e) =>
                                  handleStarClick(e, item?.spaceFeedId)
                                }
                                className="star-icon"
                                style={{
                                  color:
                                    !!auth?.jwt &&
                                    favouriteList.some(
                                      (favProduct) =>
                                        favProduct.spaceFeedId ===
                                        item?.spaceFeedId
                                    ) &&
                                    "#F5C000",
                                  cursor: "default",
                                }}
                              />
                            )}
                          </div>
                          <div className="card-body d-flex justify-content-between align-items-start">
                            <div>
                              <h5 className="card-title">
                                {item?.spaceFeed?.name}
                              </h5>
                              <p className="card-text margin-custum">
                                {item?.spaceFeed?.address1}{" "}
                                {/* {item?.spaceFeed?.city},{" "} */}
                                {/* {item?.spaceFeed?.state} {item?.spaceFeed?.pin} */}
                              </p>
                            </div>
                            <div></div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <ImageSlider
                        handleImageClick={() =>
                          navigate(`/property-detail/${item?.spaceFeedId}`)
                        }
                        handleClick={handleStarClick}
                        auth={auth}
                        height={300}
                        style={{
                          color:
                            !!auth?.jwt &&
                            favouriteList.some(
                              (favProduct) =>
                                favProduct.spaceFeedId === item?.spaceFeedId
                            ) &&
                            "#F5C000",
                          cursor: "default",
                        }}
                        settings={settings}
                        item={item?.spaceFeed}
                      />
                      <div className="card-body d-flex justify-content-between align-items-start">
                        <div>
                          <h5 className="card-title">{item?.spaceFeed?.name}</h5>
                          <p className="card-text margin-custum">
                            {item?.spaceFeed?.address1}
                            {/* {item?.spaceFeed?.city} */}
                            {/* , {item?.spaceFeed?.state} {item?.spaceFeed?.pin} */}
                          </p>
                        </div>
                        <div></div>
                      </div>
                    </>
                  )}
                </>
              )}
            </Link>
          </div>
        );
      })}
    </>
  );
};

export default FavoriteList;
